import mainTranslate from 'loankeeper-common/helpers/language'
import { formName, formNameSelector } from './constants'

export const translate = (key: string): string => mainTranslate(formName, key)
export const translateSelector = (key: string): string => mainTranslate(formNameSelector, key)
export const translateLKMessage = (key: string): string => mainTranslate('LKMESSAGE', key)
